module.exports = __webpack_public_path__ + "static/media/dokify-logo-small-grey.4471a047.svg";